import React from "react";

export const ImgCache = (props) => {
    return <img {...props} src={props.src + "?v=" + new Date().toString()} alt="" />
}
